/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Tickets_Reply_SuccessInputs */

const en_admin_tickets_reply_success = /** @type {(inputs: Admin_Tickets_Reply_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reply sent`)
};

const zh_admin_tickets_reply_success = /** @type {(inputs: Admin_Tickets_Reply_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回复已发送`)
};

/**
* | output |
* | --- |
* | "Reply sent" |
*
* @param {Admin_Tickets_Reply_SuccessInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_tickets_reply_success = /** @type {((inputs?: Admin_Tickets_Reply_SuccessInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Tickets_Reply_SuccessInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_tickets_reply_success(inputs)
	return zh_admin_tickets_reply_success(inputs)
});
export { admin_tickets_reply_success as "admin.tickets.reply_success" }